import { useId } from 'react';
import { DISC_FORMATS, type DiscFormat } from '@physical-movies/core';
import { useFormatLabels } from '../lib/labels';
import { Icon } from './Icon';
import styles from './formatChoice.module.css';

/**
 * "What is in the case?" — the one question every disc has to answer.
 *
 * Each option carries the spine colour it will give the movie on the shelf, so
 * the choice and its consequence are visible in the same place.
 */
export function FormatChoice({
  value,
  onChange,
  label,
}: {
  value: DiscFormat;
  onChange(format: DiscFormat): void;
  label: string;
}) {
  const labels = useFormatLabels();
  const name = useId();

  return (
    <fieldset className={styles.group}>
      <legend className={`eyebrow ${styles.legend}`}>{label}</legend>
      <div className={styles.options}>
        {DISC_FORMATS.map((format) => (
          <label
            key={format}
            className={`${styles.option} ${value === format ? styles.optionSelected : ''}`}
          >
            <span className={styles.spine} data-format={format} aria-hidden="true" />
            <span className={styles.text}>
              <span className={styles.name}>{labels.long(format)}</span>
              <span className={styles.hint}>{labels.hint(format)}</span>
            </span>
            <input
              type="radio"
              name={name}
              className={styles.radio}
              checked={value === format}
              onChange={() => onChange(format)}
            />
            <span className={styles.mark} aria-hidden="true">
              <Icon name="check" size={12} />
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
